"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TVLaterAlert_1 = require("./TVLaterAlert");
exports.default = TVLaterAlert_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/TVLaterAlert/index.js
// module id = 2391
// module chunks = 8